import { GuideInput } from '__generated__/globalTypes';
import { Localization } from 'static/localization/localization';
import { v4 as uuidv4 } from 'uuid';

export const useGuideCreateDefaults = () => {
    const Map: GuideInput = {
        title: Localization.NEW_MAP_TITLE,
        visualStyleId: 'default',
        guideType: 'map'
    };

    const Guide: GuideInput = {
        title: Localization.NEW_GUIDE_TITLE,
        welcomeMessage: Localization.NEW_GUIDE_MESSAGE,
        logoUrl: 'https://dvtqxks0zalev.cloudfront.net/766dcd1e-e9fd-400e-8b0a-7f761842f2a4.png',
        headerImageUrl:
            'https://dvtqxks0zalev.cloudfront.net/6550c6ac-a8f3-4cc4-8bb0-d478803c3c80.png',
        visualStyleId: 'default',
        guideType: 'guide',
        navigation: {
            tabs: [
                {
                    navigationRowId: uuidv4(),
                    type: 'home',
                    referenceId: null,
                    highlighted: false,
                    showDynamicNumber: false,
                    iconOverride: null,
                    titleOverride: null,
                    url: null
                },
                {
                    navigationRowId: uuidv4(),
                    type: 'programList',
                    referenceId: null,
                    highlighted: false,
                    showDynamicNumber: false,
                    iconOverride: null,
                    titleOverride: null,
                    url: null
                },
                {
                    navigationRowId: uuidv4(),
                    type: 'map',
                    referenceId: null,
                    url: null,
                    highlighted: false,
                    showDynamicNumber: false,
                    iconOverride: null,
                    titleOverride: null
                },
                {
                    navigationRowId: uuidv4(),
                    type: 'info',
                    referenceId: null,
                    highlighted: false,
                    showDynamicNumber: false,
                    iconOverride: null,
                    titleOverride: null,
                    url: null
                }
            ],
            drawer: [
                {
                    navigationRowId: uuidv4(),
                    type: 'home',
                    referenceId: null,
                    highlighted: true,
                    showDynamicNumber: false,
                    iconOverride: null,
                    titleOverride: null,
                    url: null
                },
                {
                    navigationRowId: uuidv4(),
                    type: 'programList',
                    referenceId: null,
                    highlighted: true,
                    showDynamicNumber: false,
                    iconOverride: null,
                    titleOverride: null,
                    url: null
                },
                {
                    navigationRowId: uuidv4(),
                    type: 'map',
                    referenceId: null,
                    url: null,
                    highlighted: true,
                    showDynamicNumber: false,
                    iconOverride: null,
                    titleOverride: null
                },
                {
                    navigationRowId: uuidv4(),
                    type: 'info',
                    referenceId: null,
                    highlighted: true,
                    showDynamicNumber: false,
                    iconOverride: null,
                    titleOverride: null,
                    url: null
                }
            ],
            homepagePrimaryModule: [
                {
                    navigationRowId: uuidv4(),
                    type: 'programList',
                    referenceId: null,
                    highlighted: false,
                    showDynamicNumber: false,
                    iconOverride: null,
                    titleOverride: null,
                    url: null
                },
                {
                    navigationRowId: uuidv4(),
                    type: 'info',
                    referenceId: null,
                    highlighted: false,
                    showDynamicNumber: false,
                    iconOverride: null,
                    titleOverride: null,
                    url: null
                }
            ]
        }
    };

    return {
        Guide,
        Map
    };
};
